import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import JourneyPreview from './components/JourneyPreview';
import BenefitsTable from './components/BenefitsTable';
import CTASection from './components/CTASection';
import FAQSection, { buildFAQSchema } from './components/FAQSection';
import SEOHead from '../../components/feature/SEOHead';

const HOME_SCHEMA = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': '#home-page',
    name: 'Neuro Elos | Avaliação Neuropsicopedagógica Infantil em São Paulo',
    description:
      'Serviço de avaliação neuropsicopedagógica infantil com base científica e acolhimento humano. Identificamos TDAH, dislexia, discalculia e dificuldades de aprendizagem em São Paulo.',
    url: 'https://neuroelos.com.br/',
    inLanguage: 'pt-BR',
    isPartOf: { '@id': '#neuroelos-website' },
    about: { '@id': '#neuroelos-local' },
    speakable: {
      '@type': 'SpeakableSpecification',
      cssSelector: ['h1', 'h2', '.speakable'],
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Início', item: 'https://neuroelos.com.br/' },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    '@id': '#servico-avaliacao',
    name: 'Avaliação Neuropsicopedagógica Infantil',
    serviceType: 'Neuropsicopedagogia',
    description:
      'Avaliação clínica completa do perfil cognitivo e de aprendizagem de crianças. Utiliza protocolos validados internacionalmente para investigar TDAH, dislexia, discalculia, disgrafia e dificuldades de aprendizagem. Inclui pré-anamnese digital, sessões de avaliação e devolutiva com relatório personalizado.',
    provider: { '@id': '#neuroelos-local' },
    areaServed: { '@type': 'State', name: 'São Paulo' },
    availableChannel: [
      { '@type': 'ServiceChannel', serviceType: 'Presencial' },
      { '@type': 'ServiceChannel', serviceType: 'Online' },
    ],
    audience: {
      '@type': 'Audience',
      audienceType: 'Pais e responsáveis por crianças em idade escolar',
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Serviços de Avaliação',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Avaliação Neuropsicopedagógica Completa' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Pré-Anamnese Digital' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Devolutiva com Plano de Intervenção' } },
      ],
    },
  },
  buildFAQSchema(),
];

export default function Home() {
  return (
    <div className="min-h-screen bg-cream font-sans">
      <SEOHead
        title="Neuro Elos | Avaliação Neuropsicopedagógica Infantil em São Paulo"
        description="Avaliação neuropsicopedagógica infantil com base científica e acolhimento humano em São Paulo. Identificamos TDAH, dislexia e dificuldades de aprendizagem com transparência e precisão clínica. Atendimento presencial e online."
        keywords="avaliação neuropsicopedagógica, avaliação psicopedagógica infantil, TDAH, dislexia, dificuldades de aprendizagem, neuropsicopedagogia São Paulo, avaliação cognitiva infantil, transtorno de aprendizagem"
        ogTitle="Neuro Elos — Avaliação Neuropsicopedagógica Infantil em São Paulo"
        ogDescription="Protocolos científicos validados, acolhimento humano e transparência em cada etapa. Entenda o perfil único do seu filho."
        lastModified="2026-03-28"
        schema={HOME_SCHEMA}
      />
      <Navbar />
      <main>
        <HeroSection />
        <JourneyPreview />
        <BenefitsTable />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
